/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
// import StructuralTypesContainer from './structural-types/container/StructuralTypesContainer';
import BuildingKindsContainer from './building-kinds/container/BuildingKindsContainer';
import AssessmentLevelsContainer from './assessment-levels/container/AssessmentLevelsContainer';
import BuildingMaterialContainer from './building-materials/container/BuildingMaterialContainer';
import BuildingComponentContainer from './building-components/container/BuildingComponentContainer';
import DepreciationRateContainer from './depreciation-rates/container/DepreciationRateContainer';
import AdditionalCostsContainer from './additional-costs/container/AdditionalCostsContainer';
import TaxCreditContainer from './tax-credit/container/TaxCreditContainer';

function BuildingSettingsContainer({ match, pathName, ordinanceRevisionId }) {
  const permissions = getJson('permissions');
  return (
    <React.Fragment>
      <div className="card-content-listing">
        <div className="container-fluid">
          <div className="row">
            <ul className="nav nav-tabs tab-container">
              {Acl(permissions, ['E2E RPT BUILDING SETTINGS BLDG KIND']) && (
                <li className="nav-item">
                  <Link
                    to="/rpt/building/settings/building-kinds"
                    className={`nav-link per-tab ${pathName.indexOf('rpt/building/settings/building-kinds') >
                      -1
                      ? 'selected'
                      : ''
                      }`}
                  >
                    Kind of Buildings
                  </Link>
                </li>
              )}
              {Acl(permissions, [
                'E2E RPT BUILDING SETTINGS ASSESSMENT LEVELS',
              ]) &&
                (
                  <li className="nav-item">
                    <Link
                      to="/rpt/building/settings/assessment-levels"
                      className={`nav-link per-tab ${pathName.indexOf(
                        'rpt/building/settings/assessment-levels'
                      ) > -1
                        ? 'selected'
                        : ''
                        }`}
                    >
                      Assessment Levels
                    </Link>
                  </li>
                )}

              {/* {Acl(permissions, ['E2E RPT BUILDING SETTINGS STRUCTURAL TYPES']) && (
                <li className="nav-item">
                  <Link
                    to="/rpt/building/settings/structural-types"
                    className={`nav-link per-tab ${pathName.indexOf('rpt/building/settings/structural-types') > -1
                        ? 'selected'
                        : ''
                      }`}
                  >
                    Structural Types
                  </Link>
                </li>
              )} */}
              {Acl(permissions, ['E2E RPT BUILDING SETTINGS MATERIAL']) && (
                <li className="nav-item">
                  <Link
                    to="/rpt/building/settings/building-materials"
                    className={`nav-link per-tab ${pathName.indexOf(
                      'rpt/building/settings/building-materials'
                    ) > -1
                      ? 'selected'
                      : ''
                      }`}
                  >
                    Building Materials
                  </Link>
                </li>
              )}
              <li className="nav-item">
                <Link
                  to="/rpt/building/settings/building-components"
                  className={`nav-link per-tab ${pathName.indexOf('rpt/building/settings/building-components') >
                    -1
                    ? 'selected'
                    : ''
                    }`}
                >
                  Building Components
                </Link>
              </li>
              {Acl(permissions, [
                'E2E RPT BUILDING SETTINGS DEPRECIATION RATES',
              ]) &&
                (
                  <li className="nav-item">
                    <Link
                      to="/rpt/building/settings/depreciation-rates"
                      className={`nav-link per-tab ${pathName.indexOf(
                        'rpt/building/settings/depreciation-rates'
                      ) > -1
                        ? 'selected'
                        : ''
                        }`}
                    >
                      Depreciation Rates
                    </Link>
                  </li>
                )}
              {/* {Acl(permissions, ['E2E RPT BUILDING SETTINGS ADDTL COSTS']) && (
                <li className="nav-item">
                  <Link
                    to="/rpt/building/settings/additional-costs"
                    className={`nav-link per-tab ${
                      pathName.indexOf(
                        'rpt/building/settings/additional-costs'
                      ) > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Additional Costs
                  </Link>
                </li>
              )} */}
              {Acl(permissions, [
                'E2E RPT BUILDING VIEW TAX CREDIT',
              ]) &&
                (
                  <li className="nav-item">
                    <Link
                      to="/rpt/building/settings/tax-credit"
                      className={`nav-link per-tab ${pathName.indexOf(
                        'rpt/building/settings/tax-credit'
                      ) > -1
                        ? 'selected'
                        : ''
                        }`}
                    >
                      Tax Credit
                    </Link>
                  </li>
                )}
            </ul>
          </div>
        </div>
        <Switch>
          {Acl(permissions, ['E2E RPT BUILDING SETTINGS BLDG KIND']) && (
            <Route
              exact
              path={`${match.path}`}
              render={() => <Redirect to={`${match.path}/building-kinds`} />}
            />
          )}
          {Acl(permissions, ['E2E RPT BUILDING SETTINGS BLDG KIND']) && (
            <Route
              path={`${match.path}/building-kinds`}
              render={() => (
                <BuildingKindsContainer
                  ordinanceRevisionId={ordinanceRevisionId}
                />
              )}
            />
          )}
          {/* {Acl(permissions, ['E2E RPT BUILDING SETTINGS COMPONENTS']) && ( */}
          <Route
            path={`${match.path}/building-components`}
            render={() => (
              <BuildingComponentContainer
                ordinanceRevisionId={ordinanceRevisionId}
              />
            )}
          />

          {/* )} */}
          {/* {Acl(permissions, ['E2E RPT BUILDING SETTINGS STRUCTURAL TYPES']) && (
            <Route
              path={`${match.path}/structural-types`}
              component={StructuralTypesContainer}
            />
          )} */}
          {Acl(permissions, [
            'E2E RPT BUILDING SETTINGS ASSESSMENT LEVELS',
          ]) &&
            (
              <Route
                path={`${match.path}/assessment-levels`}
                render={() => (
                  <AssessmentLevelsContainer
                    ordinanceRevisionId={ordinanceRevisionId}
                  />
                )}
              />
            )}
          {Acl(permissions, ['E2E RPT BUILDING SETTINGS MATERIAL']) && (
            <Route
              path={`${match.path}/building-materials`}
              component={BuildingMaterialContainer}
            />
          )}
          {Acl(permissions, [
            'E2E RPT BUILDING SETTINGS DEPRECIATION RATES',
          ]) &&
            (
              <Route
                path={`${match.path}/depreciation-rates`}
                render={() => (
                  <DepreciationRateContainer
                    ordinanceRevisionId={ordinanceRevisionId}
                  />
                )}
              />
            )}
          {Acl(permissions, [
            'E2E RPT BUILDING VIEW TAX CREDIT',
          ]) &&
            (
              <Route
                path={`${match.path}/tax-credit`}
                component={TaxCreditContainer}
              />
            )}
          {/* {Acl(permissions, ['E2E RPT BUILDING SETTINGS ADDTL COSTS']) && (
            <Route
              path={`${match.path}/additional-costs`}
              component={AdditionalCostsContainer}
            />
          )} */}
        </Switch>
      </div>
    </React.Fragment>
  );
}

BuildingSettingsContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
};

const mapStateToProps = ({ api }, { match, location }) => ({
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: _.get(api, 'AUTH/user_profile.item') || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(BuildingSettingsContainer);
